import { Component } from 'preact';
import PropTypes from 'prop-types';
import { setURLSearchParams, mapFilters } from '%/utils/filters';
import {
  setList,
  incrementFilter,
  removeFilter,
  setShowResults,
} from '../../stores/SearchFilter';

class CategoriesFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeCategories: [],
      showConversionForm: false,
    };

    const { fieldCategoryFilter } = this.props;

    window.store.SearchFilter.watch(state => {
      const selectedCategories = state.filterArray.map(
        object => object[fieldCategoryFilter],
      );

      this.setState({
        activeCategories: selectedCategories,
        showConversionForm: state.showConversionForm,
      });
    });
  }

  handleChangeCategories(categories) {
    const { fieldCategoryFilter } = this.props;
    if (fieldCategoryFilter) {
      removeFilter(fieldCategoryFilter);
      categories.forEach(category => {
        incrementFilter({ [fieldCategoryFilter]: category });
      });
      setList().then(() => {
        if (categories && categories.length > 0) {
          setShowResults(true);
        }
        if (this.props.shouldSetURLSearchParams) {
          this.applyURLSearchParams();
        }
      });
    } else {
      console.warn('Defina a prop fieldCategoryFilter');
    }
  }

  applyURLSearchParams() {
    const { filter, filterArray, sort } = window.store.SearchFilter.getState();

    const filterSimple = {
      ...filter,
      sort,
    };

    setURLSearchParams(filterSimple, filterArray, this.mapFilters());
  }

  mapFilters() {
    const { fieldCategoryFilter } = this.props;

    return {
      ...mapFilters,
      [this.props.fieldCategoryFilter]: fieldCategoryFilter,
      ...this.props.mapFilters,
    };
  }

  isActive(category) {
    const { activeCategories } = this.state;
    const noCategorySelected =
      activeCategories.length === 0 && category.length === 0;

    return activeCategories.includes(category) || noCategorySelected
      ? 'categories-filters__button--active'
      : '';
  }

  render() {
    if (this.state.showConversionForm) return null;

    return (
      <div className="categories-filters">
        <button
          type="button"
          className={`categories-filters__button ${this.isActive([])}`}
          onClick={() => this.handleChangeCategories([])}
        >
          Todos
        </button>

        {this.props.filterCategories.map(category => (
          <button
            type="button"
            className={`categories-filters__button ${this.isActive(category)}`}
            onClick={() => this.handleChangeCategories([category])}
          >
            {category}
          </button>
        ))}
      </div>
    );
  }
}

CategoriesFilter.propTypes = {
  fieldCategoryFilter: PropTypes.string,
  filterCategories: PropTypes.arrayOf(PropTypes.string),
  mapFilters: PropTypes.objectOf(),
  shouldSetURLSearchParams: PropTypes.bool,
};

export default CategoriesFilter;
